import { useEffect, useState } from "react"
import { useArticleSelection } from "../ListV2/hooks/useArticleSelection"
import { useArticleListFeaturesDisable } from "../ListV2/ArticleListConfiguration/ArticleListFeaturesDisable"
import { ArticleSelection } from "../ListV2/components/ArticleSelection"

type PureArticleSelectionProps = {
    showArticleComparision?: boolean
    selectionRef: React.RefObject<HTMLDivElement>
}

export function PureArticleSelection({ showArticleComparision, selectionRef }: PureArticleSelectionProps) {
    const { selectedArticles } = useArticleSelection()
    const [show, setShow] = useState(false)
    const disableSelection = useArticleListFeaturesDisable((x) => x.disableSelection)

    useEffect(() => {
        if (disableSelection) {
            return
        }
        setShow(!!selectedArticles.length)
    }, [selectedArticles, disableSelection])

    if (!show || disableSelection) {
        return null
    }

    return <ArticleSelection showArticleComparision={showArticleComparision} selectionRef={selectionRef} canBeOpenedInModal />
}
